import type { Commitment } from '../../types/api';
import { Reveal, Section } from '../ui';
import { summary } from '../../utils/text';

export default function Commitments({ items }: { items: Commitment[] }) {
  const list = items.filter((c) => c.enable);
  if (list.length === 0) return null;
  return (
    <Section eyebrow="Nos engagements" heading="Ce qui guide chacun de nos chantiers" background="surface" pattern="bottom-right">
      <ol className="grid gap-px bg-line sm:grid-cols-2">
        {list.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.08} className="bg-white p-8 md:p-10">
            <div className="font-display text-[3rem] font-bold leading-none text-brand">{String(i + 1).padStart(2, '0')}</div>
            <h3 className="mt-4 text-inherit font-display text-[1.75rem] font-bold normal-case leading-tight tracking-normal">{c.title}</h3>
            <p className="mt-3 max-h-[4.875rem] overflow-hidden text-[1rem] leading-relaxed text-ink">{summary(c.description, 170, 2)}</p>
          </Reveal>
        ))}
      </ol>
    </Section>
  );
}
